import React from 'react'

const FormContext = React.createContext(null)

export const Provider = FormContext.Provider
export const Consumer = FormContext.Consumer

export default FormContext
